import { type ReactNode } from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Content, ContentWrapper } from "components/partials/layout/layout";

type PageContentProps = {
  children?: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
  "data-testid"?: string;
  /** Constrain page height so children can scroll internally (e.g. sticky table headers). */
  fixedContent?: boolean;
  /** Set to false when the page has no `Breadcrumbs` of its own, to get the page's top gutter back. */
  showBreadcrumbs?: boolean;
};

const PageContent = ({
  children,
  fixedContent = false,
  showBreadcrumbs = true,
  ...rest
}: PageContentProps) => {
  return (
    <ContentWrapper data-testid="page-content" {...rest}>
      <Content sx={{ pt: 0 }} fixedContent={fixedContent} showBreadcrumbs={showBreadcrumbs}>
        {children}
      </Content>
    </ContentWrapper>
  );
};

export default PageContent;
